import { getStore } from '../store/store';
import { type MsHighContrastMode } from '../store/schema/MsHighContrastMode';

export default function getIsMsHighContrast(): boolean {
    return getStore().mode !== 0;
}
